import { render, staticRenderFns } from "./areaForAsset.vue?vue&type=template&id=45c692e5&scoped=true"
import script from "./areaForAsset.vue?vue&type=script&lang=js"
export * from "./areaForAsset.vue?vue&type=script&lang=js"
import style0 from "./areaForAsset.vue?vue&type=style&index=0&id=45c692e5&prod&scoped=true&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c692e5",
  null
  
)

export default component.exports